export default "__VITE_ASSET__C8RM9YX5__"